import ApiServiceBase from "../ApiServiceBase";
import ApiService from "../ApiService";
import { ServiceType } from "../ServiceType.data";

import {
  DocumentsListType,
  DocumentListPayload
} from "./DocumentsRepositoryService.type";

class DocumentRepositoryService {
  public getDocumentList(
    data?: DocumentListPayload
  ): DocumentsListType | Promise<DocumentsListType> {
    const service: ApiServiceBase = new ApiService(ServiceType.Eligibility);
    return service.get({
      route: ["list-documents"],
      query: { ...data }
    });
  }
}

const documentRepositoryService = new DocumentRepositoryService();

export default documentRepositoryService;
